exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-lg[data-v-3a3b2aea]{font-size:70px}.active[data-v-3a3b2aea],.btn[data-v-3a3b2aea]:hover{background-color:#666;color:#fff}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/components/pos/holdingbill.vue"],"names":[],"mappings":"AACA,yBACE,cAAgB,CACjB,AACD,qDACE,sBAAuB,AACvB,UAAa,CACd","file":"holdingbill.vue","sourcesContent":["\n.btn-lg[data-v-3a3b2aea] {\n  font-size: 70px;\n}\n.active[data-v-3a3b2aea], .btn[data-v-3a3b2aea]:hover {\n  background-color: #666;\n  color: white;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a3b2aea","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/pos/holdingbill.vue
// module id = 1278
// module chunks = 0